import styled from 'styled-components';

const TabContainer = styled.form`
  display: flex;
  flex-direction: column;
`;

export default TabContainer